import { TRUST_LABELS } from "../mock";
import { useReveal } from "../hooks/useReveal";

export const TrustBar = () => {
  const ref = useReveal();
  return (
    <section data-testid="trust-bar" className="relative border-y border-white/5 bg-[#0A1128]/40 py-16">
      <div ref={ref} className="reveal max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-8">
          <span className="overline">Trusted by leading operators</span>
        </div>

        {TRUST_LABELS.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-x-8 gap-y-6 items-center">
            {TRUST_LABELS.map((label, i) => (
              <div
                key={label}
                data-testid={`trust-logo-${i}`}
                className="font-heading text-white/40 hover:text-white/80 transition-colors duration-300 text-center text-sm tracking-[0.18em] uppercase font-medium"
              >
                {label}
              </div>
            ))}
          </div>
        ) : (
          // Logos area intentionally left blank pending approved operator references.
          <div className="mx-auto w-full max-w-xl flex items-center justify-center">
            <div className="h-px w-full bg-gradient-to-r from-transparent via-[#C19A5D]/40 to-transparent" />
          </div>
        )}
      </div>
    </section>
  );
};
